import { render } from "./AppBanner.vue?vue&type=template&id=3dbf292a&scoped=true"
import script from "./AppBanner.vue?vue&type=script&lang=js"
export * from "./AppBanner.vue?vue&type=script&lang=js"

import "./AppBanner.vue?vue&type=style&index=0&id=3dbf292a&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\peles\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dbf292a"]])

export default __exports__